/* eslint-disable */
import React, { Component } from 'react'; 
import HTMLText from '../UiComponent/HTMLText';
import IndividualPersonalInfo from './IndividualPersonalInfo'
import  './FormPage.scss'
import * as api from '../js/api.js';
import RadioButton from '../UiComponent/RadioButton'

class RaceFormTable extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			fMsg:this.props.labelText,
			raceInfo: this.props.raceInfo == null? {} :this.props.raceInfo,
			raceType: this.props.raceInfo == null ? '' : this.props.raceInfo.hasRelay == false ? 'INDIVIDUAL' : ''
		
		};		
		this.onIndividualSubmitClicked = this.onIndividualSubmitClicked.bind(this);
    }
    

    componentWillReceiveProps(nextProps) {
		this.setState({fMsg:nextProps.labelText,raceInfo:nextProps.raceInfo});
	} 
	
	componentDidMount() {   
	
	}

	componentWillUnmount() {
	}
    
  

	onIndividualSubmitClicked(info){		
		info.raceType = this.state.raceType;
		this.props.onFormSubmitClicked(info);
	}
	render() {	
		return (
            <React.Fragment>
				<table className='form-table'>
					<tbody>
						{this.state.raceInfo.hasRelay && (
							<tr className="row">
								<td>
									<HTMLText text={this.state.fMsg.raceTypeEn +":<br/>" + this.state.fMsg.raceTypeZh +":"}/>
								</td>
								<td>
									<table className='race-type-table'>
										<tbody>
											<tr>											
												<td>
													<RadioButton className='race-type' name='race-type'
														value='INDIVIDUAL' parent={this} dataField='raceType' curValue={this.state.raceType} 
														text={this.state.fMsg.individualZh + "<br/>" + this.state.fMsg.individualEn}/>          
												</td>
												<td>
													<RadioButton className='race-type' name='race-type'
														value='RELAY' parent={this} dataField='raceType' curValue={this.state.raceType} 
														text={this.state.fMsg.relayZh + "<br/>" + this.state.fMsg.relayEn}/>
												</td>
											</tr>
										</tbody>
									</table>		
								</td>
							</tr>
						)}

						{this.state.raceType == 'INDIVIDUAL' && (
							<React.Fragment>
							<input type="hidden" value="prayer" />
							<IndividualPersonalInfo raceInfo={this.state.raceInfo} showError={this.props.showError} parent={this} wording={this.state.fMsg} onSubmitClicked={this.onIndividualSubmitClicked}/>
							</React.Fragment>
						)}
					</tbody>
				</table>
            						 
            </React.Fragment>
		);
	}
}

export default RaceFormTable;